/* The signed-in home (prototype .homeB, .nb), in the telify layer. */
@layer telify {
  .band {
    padding-top: 40px;
  }

  /* The guest opening kept a little shorter, without its buttons and facts. */
  .hero [data-part='section'] {
    height: clamp(400px, calc(100vh - var(--head-h) - 300px), 560px);
  }

  .hero [data-part='name'] {
    font-size: 104px;
  }
}
